/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import AIPromptModal from '@/component/common/modal/AIPrompt/AIPromptModal';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { TextField, Dialog, CircularProgress } from '@material-ui/core';
import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { updateTabNameAfterSendMessage, onChangeChatGptModel, handleToggleUsingBasicPrompt, openPromptTicketPanel, createTmpUploadedImgs } from '../handler/ChatAIHandler';
import { sendAIChatMessage } from '@/service/chatAIService';
import { userAtom } from '@/state/atom/userAtom';
import { buildDrillDownSearchParam } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import Constant from '@/common/constant/Constant';
import moment from 'moment';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { createKibanaInteractChatAI } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { v4 as uuidv4 } from 'uuid';

import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { setPanelSelector } from '@/state/selector/panelSelector';

import { getDrilldownItemDataSelected } from "@/component/ticketList/handler/KnowledgeTicketHandler"
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useDropzone } from 'react-dropzone';
import ImageIcon from '@material-ui/icons/Image';
import { useSnackbar } from 'notistack';
import ImageCapture from '../element/ImageCapture';
import { updatePublicAPI } from '@/service/publicService';

function InputChatAI({
    setListMessageContent,
    panelId,
    tabId,
    API,
    projectInfo,
    setTriggerReload,
    filterKnowledgeListData,
    basicPrompt,
    isEnableBtnSend,
    setIsEnableBtnSend,
    listMessageContent,
    resetSearchCondition,
    corporationSelected,
    tabNameChatAI,
    titleTicket,
    setUserSelectedPrompt,
    userSelectedPrompt,
    promptInternalTicket,
    promptExternalTicket,
    setIsOpenModalReloadPage,
    isLoading,
    setIsLoading,
    usingBasicPrompt,
    setIdOfResponseMessage,
    toggleUsingKnowledgeTicketList,
    usingChatGptModel,
    setUsingChatGptModel,
    selectedMcpServers,
    usingReasoningEffort,
    setUsingReasoningEffort,

    isShowButtonStop,
    setIsShowButtonStop,
    isOnlyRunChatAI,
    setIsOnlyRunChatAI,

    setStreamedContent,
    streamedContent, 

    isStopStreamContent,
    setIsStopStreamContent,

    idOfResponseMessage,
    reasoningDataStream,
    setReasoningDataStream,  
    mcpServerOptions,
    setSelectedMcpServers
}) {
    // Fix service on
    let isUsingKnowledgeServiceValue = true;
    const [promptOpen, setPromptOpen] = useState(false);
    const [textInput, setTextInput] = useState('');
    const [toggleUsingBasicPrompt, setToggleUsingBasicPrompt] = useState(usingBasicPrompt)

    const corporationDetail = useRecoilValue(corporationAtom);
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isDisabledInputChat, setIsDisabledInputChat] = useState(false);
    const [actionError, setActionError] = useState('');

    const inputRef = useRef();
    const fileInputRef = useRef();
    const [isUploading, setIsUploading] = useState(false);
    const [uploadImgs, setUploadImgs] = useState([]);
    const [openPreviewImage, setOpenPreviewImage] = useState({isOpen: false, imgUrl: ''});
    const [isDisplayImageCapture, setIsDisplayImageCapture] = useState(false);

    const chatThreadId = filterKnowledgeListData?.threadId;
    const { enqueueSnackbar } = useSnackbar();

    const canUploadImgToSendAi = useMemo(() => {
        return OpenAiUtil.isSupportMultiModal(usingChatGptModel, usingReasoningEffort)
    }, [usingChatGptModel, usingReasoningEffort]);

    // clean up upload img
    useEffect(() => {
        return () => {
            if (Utils.isEmptyArray(uploadImgs)) return;
            for (let img of uploadImgs) {
                img.localUrl && URL.revokeObjectURL(img.localUrl);
            }
            setUploadImgs([]);
            // remove Image
        }
    }, [chatThreadId]);

    // check is can ImageCapture on mobile
    useEffect(() => {
        // setTimeout(() => {
        //     if (inputRef) {
        //         inputRef.current.focus({ preventScroll: true });
        //     }
        // }, 2000); // auto focus when open component
        if (!canUploadImgToSendAi) return;
        const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const testInput = document.createElement('input');
        testInput.type = 'file';
        const supportsCapture = 'capture' in testInput;

        setIsDisplayImageCapture(isMobile && supportsCapture);
    }, []);

    const onChangeChatInput = e => {
        setTextInput(e.target.value);
    };

    const onPasteChatInput = (e) => {
        const items = e.clipboardData.items;
        let listPastedImgs = [];

        for (const item of items) {
            if (item.kind === "file") {
                listPastedImgs.push(item.getAsFile());
            }
        }

        if (listPastedImgs.length && canUploadImgToSendAi) {
            const isValidImgs = validateUploadImages(listPastedImgs);
            if (!isValidImgs) {
                e.preventDefault();
                return;
            }

            const createImgs = listPastedImgs.map(file => ({
                id: `tmp_attach_${uuidv4()}`,
                localUrl: URL.createObjectURL(file),
                fileData: file
            }));
            setUploadImgs(prev => [...prev, ...createImgs]);

            createTmpUploadedImgs(
                corporationDetail.id,
                projectInuseDetail.id,
                chatThreadId,
                createImgs,
                setUploadImgs,
                setIsUploading
            );

            e.preventDefault();
            inputRef.current.focus();
        }
    };

    const onEnterTextInput = async e => {
        if (!isCanSendChat()) return;
        
        if(e.key === 'Enter'&& !e.shiftKey ){
            e.preventDefault();
        }
        if (
            e.key === 'Enter' &&
            isEnableBtnSend &&
            !e.shiftKey &&
            (!Utils.isEmptyString(textInput) || !Utils.isEmptyArray(uploadImgs))
        ) {
            const value = e.target.value;
            try {
                onSendMessage(value);
            } catch (error) {
                console.error('onEnterTextInput err: ', error);
                setUserSelectedPrompt([]);
                setIsEnableBtnSend(true);
            }
        }
    };

    const getOptionsSearch = () => {
        let keywordSearch = '';
        // Replace JP space
        if (filterKnowledgeListData.viewStructure?.keyword) {
            keywordSearch = filterKnowledgeListData.viewStructure?.keyword
                ?.toString()
                .replace(/\s+/g, ' ');
        }

        let keywordList = [];
        let methodSearch = Constant.SETTING_SEARCH_KEYWORD.AND;
        if(filterKnowledgeListData.viewStructure?.options?.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR){
            keywordList = [];
        }else{
             keywordList = keywordSearch ? keywordSearch.split(' ') : [];
             methodSearch = filterKnowledgeListData.viewStructure?.options?.method
                ? filterKnowledgeListData.viewStructure?.options?.method
                : Constant.SETTING_SEARCH_KEYWORD.AND
        }

        let optionSearch = {
            methodSearch: methodSearch,
            attributeSearch: filterKnowledgeListData.viewStructure?.options?.attribute
                ? filterKnowledgeListData.viewStructure?.options?.attribute
                : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
            formatSearch: '',
            keywordList: keywordList
        };

        // Search by date / time
        let fromSearchDate;
        let toSearchDate;

        let agoUnit = '';
        if (
            filterKnowledgeListData.viewStructure.options?.searchDateType ===
            Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
        ) {
            agoUnit = filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoUnit
                : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
            let agoValue = filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                ? filterKnowledgeListData.viewStructure.options?.searchDateAgoValue
                : 0;
            let agoUnitTime =
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                    ? 7 * 24 * 60 * 60 * 1000
                    : 24 * 60 * 60 * 1000;

            // toSearchDate is today
            toSearchDate = moment(new Date()).format('YYYY/MM/DD');

            // 0 days ago
            if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
                fromSearchDate = toSearchDate;
            } else if (
                !agoValue &&
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
            ) {
                // 0 week ago = monday - today
                fromSearchDate = moment()
                    .startOf('isoweek')
                    .format('YYYY/MM/DD');
            } else {
                fromSearchDate = moment(new Date() - agoValue * agoUnitTime).format('YYYY/MM/DD');
            }

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;
        } else {
            if (filterKnowledgeListData.viewStructure.options?.from) {
                fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
                optionSearch.fromSearchDate = filterKnowledgeListData.viewStructure.options.from;
            }

            if (filterKnowledgeListData.viewStructure.options?.to) {
                toSearchDate = filterKnowledgeListData.viewStructure.options.to;
                optionSearch.toSearchDate = filterKnowledgeListData.viewStructure.options.to;
            }

            if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
                // switch search date
                let newFromSearchDate = toSearchDate;
                let newToSearchDate = fromSearchDate;

                fromSearchDate = newFromSearchDate;
                toSearchDate = newToSearchDate;

                optionSearch.fromSearchDate = fromSearchDate;
                optionSearch.toSearchDate = toSearchDate;
            }
        }

        if (filterKnowledgeListData?.viewStructure?.options?.otherFields) {
            optionSearch.formatSearch = JSON.stringify(
                filterKnowledgeListData.viewStructure.options.otherFields
            );
        }

        // Sort
        optionSearch.sortType = filterKnowledgeListData?.viewStructure?.options?.hasOwnProperty('sort') && filterKnowledgeListData?.viewStructure?.options['sort']
            ? filterKnowledgeListData.viewStructure?.options['sort']
            : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

        if(filterKnowledgeListData.viewStructure?.options?.getListPdfPage){
            optionSearch.getListPdfPage = filterKnowledgeListData.viewStructure?.options?.getListPdfPage
        }

        if(!Utils.isEmptyString(filterKnowledgeListData.viewStructure?.options?.filePdfId)){
            optionSearch.filePdfId = filterKnowledgeListData.viewStructure?.options?.filePdfId
        }

        optionSearch.isIncludeAttachPdf = 1
        optionSearch.isIncludePdfPage = 1
        optionSearch.isSearchSynonym = 0
        
        return optionSearch;
    };

    const onSendMessage = async value => {
        if (!isCanSendChat()) return;
        setReasoningDataStream()
        let chatPostId = uuidv4()
        let tabName = tabNameChatAI;

        const isRunSdauto = value.startsWith(Constant.SD_AUTO_COMMAND);
        
        if (!isRunSdauto) {
            setTimeout(async() => {
                setIsShowButtonStop(true);
            }, 200)
            setIsOnlyRunChatAI(true);
            setIsStopStreamContent('');
        }
        // handle attachImg
        let attachments = [];
        if (canUploadImgToSendAi && !Utils.isEmptyArray(uploadImgs) && !isRunSdauto) {
            attachments = uploadImgs.map(img => ({
                localUrl: img.localUrl,
                s3Path: img.s3Path,
                thumbnailInfo: img.thumbnailInfo
            }));
        }

        const mock = [
            {
                isFromMe: true,
                user: Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail),
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                content: value,
                attachments,
                postType: !Utils.isEmptyArray(attachments)
                    ? Constant.POST_TYPE.IMAGE : Constant.POST_TYPE.MSG
            },
            //HIDDEN MESSAGE WARNING WHEN EXCEED MAX TOKEN
            {
                isFromMe: false,
                content: I18n.get('WARNING_EXCEED_MAX_TOKEN'),
                isWaring: true,
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                isHidden: true
            },
            {
                isFromMe: false,
                isLoadingMessage: true,
                idOfLoadingMessage: uuidv4()
            }
        ];
        if (listMessageContent?.length === 0) {
            tabName = value;
            if (Utils.isEmptyString(tabName) && !Utils.isEmptyArray(uploadImgs)) {
                const firstUploadImg = uploadImgs[0];
                const fileName = firstUploadImg?.fileData?.name;
                tabName = fileName || '';
            }
            updateTabNameAfterSendMessage(tabName, panelId, setPanelList, tabId);
        }

        setListMessageContent(prev => [...prev, ...mock]);
        setIsEnableBtnSend(false);
        setTextInput('');
        setUploadImgs([]);

        let drillDown = buildDrillDownSearchParam(filterKnowledgeListData?.viewStructure);
        let optionSearch = getOptionsSearch();

        let corporationId = corporationDetail.id;
        if (!Utils.isEmptyObject(projectInfo)) {
            corporationId = projectInfo?.affiliationOrganization;
        }
        const drillDownDataForLog = await getDrilldownItemDataSelected(API, filterKnowledgeListData?.viewStructure)
        const dataLog = {
            corporationDetail: corporationDetail,
            projectDetail: projectInuseDetail,
            userDetail: userDetail,
            rootProjectDetail: projectInfo,
            rootCorporationDetailId: corporationSelected,
            tabNameChatAI: `${tabName} ${tabId}`,
            aiChatInquiryText: value,
            basicPromptID: toggleUsingBasicPrompt ? basicPrompt : null,
            basicPromptName: toggleUsingBasicPrompt ? titleTicket : null,
            userSelectedPrompt: userSelectedPrompt,
            projectIdKnowledgeSelected: filterKnowledgeListData?.projectIdKnowledgeSelected,
            keyword: filterKnowledgeListData?.viewStructure?.keyword,
            viewName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, filterKnowledgeListData?.viewSelected?.name),
            searchTagSuggestKnowledge: Utils.createTagForLogKibana(drillDownDataForLog),
            isTurnOnToggleUsingKnowledgeTicketList: toggleUsingKnowledgeTicketList
        }

        const logKibanaData = createKibanaInteractChatAI(dataLog);
        let listUrlShareLink = Utils.getShareLinkUrls(value)
        const dto = {
            corporationId: corporationId,
            projectId: filterKnowledgeListData?.projectIdKnowledgeSelected,
            currentUserId: userDetail.id,
            chatThreadId: chatThreadId,
            message: value,
            basePrompt: isUsingKnowledgeServiceValue ? basicPrompt : '',
            usingBasicPrompt: isUsingKnowledgeServiceValue ? usingBasicPrompt : false,

            visibilitySettingType: filterKnowledgeListData?.viewStructure?.visibility
                ? filterKnowledgeListData?.viewStructure?.visibility : Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
            visibilitySetting: 'new_arrived_knowledge',
            publicRange: '',
            projectInuse: projectInuseDetail.id,
            userAffiliationOrganization: userDetail.affiliationOrganization,
            projectInuseType: projectInuseDetail.type,
            viewId: filterKnowledgeListData?.viewSelectedId,
            optionSearch: optionSearch,
            drillDownSearch: drillDown,
            ticketIdList: [],
            ticketProperty: filterKnowledgeListData?.viewStructure?.ticketProperty,
            resetSearchCondition: isUsingKnowledgeServiceValue ? resetSearchCondition : false,
            from: 0,
            size: 30,
            logKibanaData: JSON.stringify(logKibanaData),
            chatPostId: chatPostId,
            listUrlShareLink: listUrlShareLink,
            currentCorporationId: corporationDetail.id,
            ticketCreatedProjectId: filterKnowledgeListData.ticketCreatedProjectId,
            ticketCreatedCorporationId: filterKnowledgeListData.ticketCreatedCorporationId,
            chatGptModel: usingChatGptModel,
            attachments: canUploadImgToSendAi && !Utils.isEmptyArray(uploadImgs) && !isRunSdauto
                ? JSON.stringify(uploadImgs.map(img => ({
                        s3Path: img.s3Path,
                        fileInfo: Utils.normalizeFileData(img?.fileData),
                        thumbnailInfo: img.thumbnailInfo
                    })))
                : JSON.stringify([]),
            selectedMcpServers: selectedMcpServers || [],
            reasoningEffort: usingReasoningEffort
        };
        
        setUserSelectedPrompt([]);
        setIdOfResponseMessage(chatPostId)
        onChangeChatGptModel(
            setPanelList,
            panelId,
            tabId,
            usingChatGptModel,
            setUsingChatGptModel,
            selectedMcpServers,
            usingReasoningEffort,
            setUsingReasoningEffort
        );

        sendAIChatMessage(API, dto, setListMessageContent, setIsDisabledInputChat)

        if (isRunSdauto) {
            updatePublicAPI(null, {
                updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.REMOVE_UPLOAD_S3_FILE_LIST,
                s3PathList: uploadImgs.map(img => img.s3Path)
            });
        }
        return;
    };

    const onStopMessage = async value => {
        setIsShowButtonStop(false);
        setIsStopStreamContent(Constant.STREAM_STATUS.STOP);
        setIsEnableBtnSend(true);
        let reasoningData = [];
         if(!Utils.isEmptyArray(reasoningDataStream)){
            reasoningData = reasoningDataStream?.filter(item => !item.isDone)?.map(item =>  `${item.title}\n${item.text}`);
        }
         if (Utils.isEmptyString(streamedContent) && Utils.isEmptyArray(reasoningDataStream)) {
            setListMessageContent(prevList =>
                prevList.filter(
                    item => !(item.isLoadingMessage)
                )
            );
        }else{
            let findIndex = listMessageContent?.findIndex(item => item.isLoadingMessage)
            let message = listMessageContent[findIndex];
            let listMessageClone = [...listMessageContent];
            let newMessage = {
                isFromMe: false,
                content: streamedContent,
                dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE,
                postType: 'msg',
                id: message.idOfLoadingMessage,
                reasoningData: reasoningDataStream
            };
            listMessageClone[findIndex] = newMessage;
            setListMessageContent([...listMessageClone])
        }

       
        // call update stop
        let param = {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.CREATE_OR_UPDATE_AI_CHATPOST,
            data: {
                id: idOfResponseMessage,
                corporationId: corporationDetail.id,
                affiliationProject: projectInuseDetail.id,
                postType: Constant.POST_TYPE.MSG,
                chatThreadId: chatThreadId,
                role: 'assistant',
                content: streamedContent,
                creatorId: 'chatGPT',
                streamStatus: Constant.STREAM_STATUS.STOP,
                reasoning: reasoningData
            }
        };
        
        await updatePublicAPI(API, param);
    }

    const validateUploadImages = useCallback((images = []) => {
        const count = uploadImgs.length + images.length;
        const MAX_IMAGE_UPLOAD_COUNT = 10;
        if (count > MAX_IMAGE_UPLOAD_COUNT) {
            enqueueSnackbar(I18n.get('INVALID_TOO_MANY_IMAGES'), {
                variant: 'error',
                autoHideDuration: 2000
            });
            return false;
        }

        for (let file of images) {
            const isTooLarge = file.size > 20 * 1024 * 1024; // 20MB
            const isValidType = /image\/(jpeg|png|gif|webp)/.test(file.type);

            if (!isValidType) {
                enqueueSnackbar(I18n.get('INVALID_AI_SUPPORT_IMAGE_TYPE'), {
                    variant: 'error',
                    autoHideDuration: 2000
                });
                return false;
            }

            if (isTooLarge) {
                enqueueSnackbar(I18n.get('INVALID_TOO_LARGE_IMAGE'), {
                    variant: 'error',
                    autoHideDuration: 2000
                });
                return false;
            }
        }

        return true;
    }, [uploadImgs]);

    const onDrop = useCallback((acceptedFiles) => {
        if (!canUploadImgToSendAi) return;
        if (!acceptedFiles || Utils.isEmptyArray(acceptedFiles)) return;
        const isValidImgs = validateUploadImages(acceptedFiles);
        if (!isValidImgs) return;

        const imgs = acceptedFiles.map(file => ({
            id: `tmp_attach_${uuidv4()}`,
            localUrl: URL.createObjectURL(file),
            fileData: file
        }));
        setUploadImgs(prev => [...prev, ...imgs]);
        inputRef.current.focus();
        createTmpUploadedImgs(
            corporationDetail.id,
            projectInuseDetail.id,
            chatThreadId,
            imgs,
            setUploadImgs,
            setIsUploading
        );
    }, [uploadImgs, canUploadImgToSendAi]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true
    });

    const handleSelectImages = (event) => {
        const selectedImgs = Array.from(event.target.files);
        if (!selectedImgs || Utils.isEmptyArray(selectedImgs)) {
            event.target.value = '';
            return;
        }
        const isValidImgs = validateUploadImages(selectedImgs);
        if (!isValidImgs) {
            event.target.value = '';
            return;
        }

        const imgs = selectedImgs.map(file => ({
            id: `tmp_attach_${uuidv4()}`,
            localUrl: URL.createObjectURL(file),
            fileData: file
        }));
        setUploadImgs(prev => [...prev, ...imgs]);
        inputRef.current.focus();
        createTmpUploadedImgs(
            corporationDetail.id,
            projectInuseDetail.id,
            chatThreadId,
            imgs,
            setUploadImgs,
            setIsUploading
        );

        event.target.value = ''; // reset after selected
    };

    const removeUploadedImage = (removeImg) => {
        setUploadImgs((preImg) => preImg.filter(img => img.id !== removeImg.id));
        removeImg.localUrl && URL.revokeObjectURL(removeImg.localUrl);
        updatePublicAPI(null, {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.DELETE_S3_FILE_BY_PATH,
            s3Path: removeImg.s3Path
        });
    };

    const isDisplayPromptBtn = () => {
        const isHidden = filterKnowledgeListData?.projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG || isLoading;
        return !isHidden;
    }

    const isCanSendChat = () => {
        if (!isEnableBtnSend) return false;
        if (isUploading) return false;
        if (!Utils.isEmptyArray(uploadImgs)) return true;
        const inputText = textInput?.trim()
        return !Utils.isEmptyString(inputText)
    }
    
    return (
        <div className="chat-input-wrapper" {...getRootProps()}>
            {/* {isDragActive && <div className="dropzone-overlay" />} */}
            {isUsingKnowledgeServiceValue && basicPrompt && (
                <div className="basic-prompt-chip">
                    <OverFlowTooltipWithTabsMui
                        value={I18n.get('LABEL-BASIC-PROMPT')}
                        className={`name-title-tickets`}
                        onClick={()=> openPromptTicketPanel(
                            setIsLoading,
                            userDetail,
                            basicPrompt,
                            projectInuseDetail,
                            setIsOpenModalReloadPage,
                            addNewPanel,
                            setIsOpenAccessDeniedPopup,
                            corporationDetail,
                            setActionError
                        )}
                    />
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-basicPrompt-mode`}
                            checked={toggleUsingBasicPrompt}
                            value={toggleUsingBasicPrompt}
                            onChange={() => 
                                handleToggleUsingBasicPrompt(
                                    panelList,
                                    setPanelList,
                                    panelId,
                                    tabId,
                                    toggleUsingBasicPrompt,
                                    setToggleUsingBasicPrompt
                            )}
                        />
                        <label htmlFor={`switch-basicPrompt-mode`}></label>
                    </div>
                </div>
            )}

            {/* Preview Images Container */}
            {canUploadImgToSendAi && !Utils.isEmptyArray(uploadImgs) && (
                <div className="ai-chat-input-preview-images">
                    {uploadImgs.map((previewImg, index) => (
                        <div key={previewImg.id} className='ai-chat-input-preview-img-item'>
                            <img
                                src={previewImg.localUrl}
                                alt={`upload-${index}`}
                                className="ai-chat-input-preview-img"
                                onClick={() => {
                                    if (!previewImg.s3Path) return;
                                    setOpenPreviewImage({
                                        isOpen: true,
                                        imgUrl: previewImg.localUrl
                                    });
                                }}
                            />
                            {previewImg.s3Path && (
                                <button
                                    className="ai-chat-input-remove-btn"
                                    onClick={() => {
                                        if (!previewImg.s3Path) return;
                                        removeUploadedImage(previewImg);
                                    }}
                                >
                                    &times;
                                </button>
                            )}
                            {!previewImg.s3Path && (
                                <CircularProgress size="0.6rem" thickness={6} className='loading-create-thumbnail'/>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* Form AiChat Input Container */}
            <div className="groupForm-chat groupForm-ai-chat">
                <div className="group-fild">
                    <div className="formField" data-cy="chat-form-input-field">
                        <TextField
                            multiline
                            name="chatbotName"
                            maxRows={15}
                            className={`form-control ${isDisplayImageCapture ? "more-padding" : "no-more-padding"} ai-send-input`}
                            variant="outlined"
                            autoComplete="off"
                            placeholder="あなたのメッセージ..."
                            onChange={onChangeChatInput}
                            onPaste={onPasteChatInput}
                            value={textInput}
                            onKeyDown={async e => await onEnterTextInput(e)}
                            disabled={isDisabledInputChat}
                            spellCheck={false}
                            inputRef={inputRef}
                            // autoFocus
                        />
                    </div>

                    <div className="ai-chat-group-btns">
                        {/* Image capture */}
                        {canUploadImgToSendAi && isDisplayImageCapture && (
                            <ImageCapture
                                corporationDetail={corporationDetail}
                                projectInuseDetail={projectInuseDetail}
                                chatThreadId={chatThreadId}
                                setUploadImgs={setUploadImgs}
                                setIsUploading={setIsUploading}
                                validateUploadImages={validateUploadImages}
                            />
                        )}

                        {/* Upload multi image / drag-drop */}
                        {canUploadImgToSendAi && (
                            <div>
                                <button
                                    className="btn-reset-default ai-chat-input-btn"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <ImageIcon onDragStart={e => {e.preventDefault()}} />
                                </button>
                                <input
                                    style={{ display: 'none' }}
                                    {...getInputProps()} draggable="false"
                                    ref={fileInputRef}
                                    type="file"
                                    multiple
                                    onChange={handleSelectImages}
                                />
                            </div>
                        )}

                        {/* Open Prompt Btn */}
                        {isDisplayPromptBtn() && (
                            <button
                                className="btn-reset-default ai-chat-input-btn"
                                onClick={() => setPromptOpen(!promptOpen)}
                            >
                                <img src="/assets/image/prompt-icon.svg" alt="" className='ai-chat-send-msg-btn-icon'/>
                            </button>
                        )}
                    </div>
                </div>

                {/* SendAiChat Btn */}
                {
                    !isShowButtonStop && 
                    <button
                        className="btn-reset-default ai-chat-send-msg-btn"
                        disabled={!isCanSendChat()}
                        onClick={async () => await onSendMessage(textInput)}
                    >
                        <img src="/assets/image/icon-send.svg" alt="" className='ai-chat-send-msg-btn-icon'/>
                    </button>
                }
                
                { isShowButtonStop && 
                    <button
                        className="btn-reset-default ai-chat-send-msg-btn"
                        onClick={async () => await onStopMessage(textInput)}
                    >
                        <img src="/assets/image/button-stop.svg" alt="" className='ai-chat-send-msg-btn-icon'/>
                    </button>
                }
            </div>

            {/* Modals / Dialogs */}
            {promptOpen && (
                <AIPromptModal
                    isOpen={promptOpen}
                    setIsOpen={setPromptOpen}
                    corporationDetail={corporationDetail}
                    projectInuseDetail={projectInfo}
                    API={API}
                    setTriggerReload={setTriggerReload}
                    setTextInput={setTextInput}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    corporationSelected={corporationSelected}
                    promptInternalTicket={promptInternalTicket}
                    promptExternalTicket={promptExternalTicket}
                    setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                    setPromptOpen={setPromptOpen}
                    setUsingChatGptModel={setUsingChatGptModel}
                    setUsingReasoningEffort={setUsingReasoningEffort}
                    setSelectedMcpServers={setSelectedMcpServers}
                    selectedMcpServers={selectedMcpServers}
                    mcpServerOptions={mcpServerOptions}
                    panelList={panelList}
                    setPanelList={setPanelList}
                    panelId={panelId}
                    tabId={tabId}
                />
            )}
            
            <Dialog
                maxWidth="md"
                open={openPreviewImage.isOpen}
                onClose={() => setOpenPreviewImage({isOpen: false, imgUrl: ''})}
            >
                <img
                    alt="preview-full"
                    src={openPreviewImage.imgUrl}
                    style={{
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                    }}
                />
            </Dialog>

            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog 
                isOpen={!Utils.isEmptyString(actionError)} 
                okCallBack={() => {setActionError('')}} 
                msgConfirm={actionError}
                textSubmit={I18n.get('OK')}
            />
        </div>
    );
}

InputChatAI.propTypes = {
    setListMessageContent: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    API: PropTypes.any,
    projectInfo: PropTypes.any,
    setTriggerReload: PropTypes.any,
    filterKnowledgeListData: PropTypes.any,
    basicPrompt: PropTypes.any,
    isEnableBtnSend: PropTypes.any,
    setIsEnableBtnSend: PropTypes.any,
    listMessageContent: PropTypes.any,
    resetSearchCondition: PropTypes.any,
    corporationSelected: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    titleTicket: PropTypes.any,
    setUserSelectedPrompt: PropTypes.any,
    userSelectedPrompt: PropTypes.any,
    promptInternalTicket: PropTypes.any,
    promptExternalTicket: PropTypes.any,
    setIsOpenModalReloadPage: PropTypes.any,
    isLoading: PropTypes.any,
    setIsLoading: PropTypes.any,
    usingBasicPrompt: PropTypes.any,
    setIdOfResponseMessage: PropTypes.any,
	usingChatGptModel: PropTypes.any,
	setUsingChatGptModel: PropTypes.any,
	toggleUsingKnowledgeTicketList: PropTypes.any,
	selectedMcpServers: PropTypes.array,

    isShowButtonStop: PropTypes.any,
    setIsShowButtonStop: PropTypes.any,
    isOnlyRunChatAI: PropTypes.any,
    setIsOnlyRunChatAI: PropTypes.any,

    setStreamedContent: PropTypes.any,
    streamedContent: PropTypes.any,

    isStopStreamContent: PropTypes.any,
    setIsStopStreamContent: PropTypes.any,

    idOfResponseMessage: PropTypes.any,
};

export default InputChatAI;
